import { Link } from 'react-router-dom'
import { kapitelIndex } from '../lib/content'
import { useSidTitel } from '../lib/seo'

export default function Start() {
  useSidTitel()
  const kapitel = kapitelIndex.filter((k) => k.publicerad && k.slug)

  return (
    <div className="wrap">
      <section className="hero">
        <span className="hero-etikett">Gymnasiet · Gy25 · 100 poäng</span>
        <h1>Ledarskap och organisation</h1>
        <p>
          Ett digitalt läromedel för kursen Ledarskap och organisation, nivå 1. Här lär du dig
          hur grupper fungerar, vad som motiverar människor, hur konflikter kan hanteras och vad
          som kännetecknar ett välfungerande ledarskap. Varje kapitel innehåller lärotext,
          begrepp att träna på, instuderingsfrågor, övningsuppgifter och en avslutande quiz.
        </p>
        <div className="hero-knappar">
          <Link className="knapp knapp-primar" to={`/kapitel/${kapitel[0]?.slug}`}>
            Börja läsa
          </Link>
          <Link className="knapp knapp-sekundar" to="/skriv-ut">
            🖨 Skriv ut hela läromedlet
          </Link>
        </div>
      </section>

      <section aria-labelledby="kapitel-rubrik">
        <h2 className="sektionsrubrik" id="kapitel-rubrik">Kapitel</h2>
        <p className="sektionsingress">Läromedlet omfattar {kapitel.length} kapitel.</p>
        <div className="kapitelrutnat">
          {kapitel.map((k) => (
            <Link key={k.id} to={`/kapitel/${k.slug}`} className="kapitelkort">
              <span className="chip chip-las">Läs</span>
              <span className="kapitelkort-nr">KAPITEL {k.id}</span>
              <h3>{k.titel}</h3>
              <p>{k.beskrivning}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  )
}
